/* eslint-disable */
import React, { Fragment, useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Autocomplete from "react-google-autocomplete";
import { parseAddressParts } from "../../../helpers/helpers";
import SummaryItem from "../../../components/CaseGenerator/components/SummaryItem/SummaryItem";
import "./PlaceSearch.scss";
export default function PlaceSearch(props) {
  let {
    errorText,
    onSelect,
    placeholder,
    suggestionType,
    restrictions,
    street,
    validationSchema,
    ...rest
  } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const [value, setValue] = useState(field.value);
  const [isOpen, setIsOpen] = useState(false);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  let type;
  switch (suggestionType) {
    case "regions":
      type = ["(regions)"];
      break;
    case "cities":
      type = ["(cities)"];
      break;
    case "addresses":
    default:
      type = ["address"];
      break;
  }

  if (!restrictions) {
    restrictions = { country: "IT" };
  }

  const { summaryMode } = rest;
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState(field.value);

  useEffect(() => {
    setFieldValue(field.name, currentValue);
  }, [value, field.name, currentValue]);

  const handleSuggestionSelected = (payload) => {
    if (onSelect) {
      const via = parseAddressParts(payload.address_components).via;
      const comune = parseAddressParts(payload.address_components).comune;

      setCurrentValue(!street ? (via ? via : "") : comune);
      onSelect(parseAddressParts(payload.address_components), setFieldValue);
    }
  };

  return (
    <Form.Group>
      {!summaryMode ? (
        <>
          <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
            {rest.label}
          </Form.Label>
          <Fragment>
            <Form.Control
              type="hidden"
              name={field.name}
              // to deal with the translations for the plaholder [object Object]
              placeholder={
                typeof placeholder === "object"
                  ? t(placeholder.props.i18nKey)
                  : placeholder
              }
              value={field.value}
              onChange={field.onChange}
              className={meta.touched && meta.error ? "is-invalid" : "nothing"}
              id={field.name + "-hidden"}
            />

            <Autocomplete
              className={
                (meta.touched && meta.error
                  ? "form-control is-invalid"
                  : "form-control") +
                (isOpen && field.value
                  ? " pac-target-input google-address-open"
                  : " pac-target-input")
              }
              onPlaceSelected={handleSuggestionSelected}
              placeholder={
                typeof placeholder === "object"
                  ? t(placeholder.props.i18nKey)
                  : placeholder
              }
              types={type}
              value={currentValue}
              onChange={(e) => {
                setCurrentValue(e.target.value);
              }}
              onFocus={() => setIsOpen(true)}
              onBlur={() => setIsOpen(false)}
              componentRestrictions={restrictions}
              aria-describedby={
                meta.touched && meta.error ? field.name + "-error" : null
              }
              required={isRequired}
              id={field.name}
            />

            {meta.touched && meta.error && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </p>
            )}
          </Fragment>
        </>
      ) : (
        <>
          <span className="paragraph-small-fs9">
            {rest.label}
          </span>
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
    </Form.Group>
  );
}
